import { Translation, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule, TranslocoService,
  TRANSLOCO_TRANSPILER, DefaultTranspiler,
  TRANSLOCO_MISSING_HANDLER, DefaultMissingHandler,
  TRANSLOCO_INTERCEPTOR, DefaultInterceptor,
  TRANSLOCO_FALLBACK_STRATEGY,
  DefaultFallbackStrategy} from '@jsverse/transloco';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

// @ts-ignore
@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        {
            // Provide the default Transloco configuration
            provide : TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs      : [
                    {
                        id   : 'en',
                        label: 'English'
                    },
                    {
                        id   : 'tr',
                        label: 'Turkish'
                    }
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : environment.production
            })
        },
        {
            // Provide the default Transloco loader
            provide : TRANSLOCO_LOADER,
            useClass: TranslocoHttpLoader
        },
        {
            provide : TRANSLOCO_TRANSPILER,
            useClass: DefaultTranspiler
        },
        {
            provide : TRANSLOCO_MISSING_HANDLER,
            useClass: DefaultMissingHandler
        },
        {
            provide : TRANSLOCO_INTERCEPTOR,
            useClass: DefaultInterceptor
        },
        {
            provide : TRANSLOCO_FALLBACK_STRATEGY,
            useClass: DefaultFallbackStrategy
        },
        {
            // Preload the default language before the app starts to prevent empty/jumping content
            provide   : APP_INITIALIZER,
            deps      : [TranslocoService],
            useFactory: (translocoService: TranslocoService): any => (): Promise<Translation> => {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return translocoService.load(defaultLang).toPromise();
            },
            multi     : true
        }
    ]
})
export class TranslocoCoreModule
{
}
